var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 306 345",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M302.107,258.262c2.401,-4.159 3.893,-8.845 3.893,-13.053l0,-146.069c0,-4.208 -1.49,-8.893 -3.892,-13.052l-149.108,86.087l149.107,86.087Z",
    style: {
      fill: "#00599c",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.25,341.193l126.5,-73.034c3.644,-2.104 6.956,-5.737 9.357,-9.897l-149.107,-86.087l-149.107,86.088c2.401,4.159 5.714,7.793 9.357,9.896l126.5,73.034c7.287,4.208 19.213,4.208 26.5,-0Z",
    style: {
      fill: "#004482",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.108,86.087c-2.402,-4.16 -5.715,-7.793 -9.358,-9.897l-126.5,-73.034c-7.287,-4.208 -19.213,-4.208 -26.5,0l-126.5,73.034c-7.288,4.207 -13.25,14.535 -13.25,22.95l0,146.069c0,4.208 1.491,8.894 3.893,13.053l149.107,-86.087l149.108,-86.088Z",
    style: {
      fill: "#659ad2",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M153,274.175c-56.243,0 -102,-45.757 -102,-102c0,-56.243 45.757,-102 102,-102c36.292,0 70.139,19.53 88.331,50.968l-44.143,25.544c-9.105,-15.736 -26.038,-25.512 -44.188,-25.512c-28.122,0 -51,22.878 -51,51c0,28.121 22.878,51 51,51c18.152,0 35.085,-9.776 44.191,-25.515l44.143,25.543c-18.192,31.441 -52.04,50.972 -88.334,50.972Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M255,166.508l-11.334,0l0,-11.333l-11.332,0l0,11.333l-11.334,0l0,11.333l11.334,0l0,11.334l11.332,0l0,-11.334l11.334,0l0,-11.333Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M297.5,166.508l-11.334,0l0,-11.333l-11.332,0l0,11.333l-11.334,0l0,11.333l11.334,0l0,11.334l11.332,0l0,-11.334l11.334,0l0,-11.333Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCLogo);
export default __webpack_public_path__ + "static/media/c_logo.aac392bac23828df5917d30231f795cd.svg";
export { ForwardRef as ReactComponent };